import { render, staticRenderFns } from "./PopupExit.vue?vue&type=template&id=67541456&"
import script from "./PopupExit.vue?vue&type=script&lang=js&"
export * from "./PopupExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports